import keyMirror from 'keymirror';

export default keyMirror({
    MODAL_TOGGLE: null,
    MODAL_CANCEL: null,

    INTENT_INITIALIZE: null,
    INTENT_CANCEL: null,
    INTENT_RESOLVE: null,

    CONTEXT_TOGGLE: null,

    OVERLAY_TOGGLE: null,

    UPLOAD_MODAL_TOGGLE: null,
    UPLOAD_ADD: null,
    UPLOAD_PROGRESS: null,
    UPLOAD_FINISHED: null,

    MESSAGES_MARK: null,
    MESSAGES_FETCHED: null,
    NEW_MESSAGE: null,

    APPLICATION_HALT: null,
    APPLICATION_RESUME: null,

    TOGGLE_CREATED_EVENT_MODAL: null
});
